import React from "react";
import { AlertTriangle, RotateCcw, Home } from "lucide-react";
import { Button } from "@/components/ui/button";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info);
  }

  reset = () => this.setState({ error: null });

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#050505] p-6 text-white" data-testid="error-boundary">
        <div className="max-w-md text-center">
          <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-red-500/15 ring-1 ring-red-500/30">
            <AlertTriangle className="h-6 w-6 text-red-300" />
          </div>
          <h1 className="font-display mt-6 text-3xl font-light tracking-tight">Something broke.</h1>
          <p className="mt-2 text-sm text-white/55">
            A client-side error stopped the page. We've logged it. Try reloading — your work is saved.
          </p>
          {this.state.error?.message && (
            <pre className="mt-4 max-h-32 overflow-auto rounded-xl border border-white/10 bg-white/[0.02] p-3 text-left text-[11px] text-red-300/85">
              {String(this.state.error.message)}
            </pre>
          )}
          <div className="mt-6 flex flex-col items-center justify-center gap-2 sm:flex-row">
            <Button
              onClick={() => { this.reset(); window.location.reload(); }}
              className="rounded-full bg-white text-black hover:bg-zinc-200"
              data-testid="error-reload"
            >
              <RotateCcw className="mr-1.5 h-4 w-4" /> Reload page
            </Button>
            <Button
              onClick={() => { this.reset(); window.location.href = "/"; }}
              variant="outline"
              className="rounded-full border-white/15 bg-white/5 text-white hover:bg-white/10"
              data-testid="error-home"
            >
              <Home className="mr-1.5 h-4 w-4" /> Back to home
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
